import type { Product } from '../pages/products/components/ProductCard';

export const allProducts: Product[] = [
  // Engine
  {
    id: 1,
    name: 'Heavy Duty Air Filter Assembly',
    category: 'engine',
    brand: 'MAHLE',
    image: 'https://public.readdy.ai/ai/img_res/cc1b8aafd8eb19b1fbe07840cbb43d58.jpg',
    inStock: true,
    featured: true,
  },
  {
    id: 2,
    name: 'Premium Engine Oil Filter',
    category: 'engine',
    brand: 'Mann-Filter',
    image: 'https://readdy.ai/api/search-image?query=Truck%20engine%20oil%20filter%20set%20on%20clean%20light%20gray%20background%2C%20professional%20automotive%20parts%20photography%2C%20cylindrical%20oil%20filters%20metallic%20silver%20details%2C%20commercial%20product%20studio%20shot&width=400&height=400&seq=oil-filter-p2&orientation=squarish',
    inStock: true,
  },
  {
    id: 3,
    name: 'Fuel Pump Assembly',
    category: 'engine',
    brand: 'Bosch',
    image: 'https://readdy.ai/api/search-image?query=Truck%20diesel%20fuel%20pump%20assembly%20on%20clean%20light%20gray%20background%2C%20professional%20automotive%20parts%20photography%2C%20precision%20mechanical%20pump%20components%2C%20commercial%20product%20shot&width=400&height=400&seq=fuel-pump-p3&orientation=squarish',
    inStock: true,
  },
  {
    id: 4,
    name: 'Complete Radiator Assembly',
    category: 'engine',
    brand: 'Nissens',
    image: 'https://readdy.ai/api/search-image?query=Heavy%20duty%20truck%20aluminum%20radiator%20assembly%20on%20clean%20light%20gray%20background%2C%20professional%20automotive%20cooling%20system%20parts%20photography%2C%20metal%20fins%20and%20hose%20connections%2C%20commercial%20product%20shot&width=400&height=400&seq=radiator-p4&orientation=squarish',
    inStock: true,
  },
  {
    id: 5,
    name: 'Turbocharger Cartridge',
    category: 'engine',
    brand: 'Garrett',
    image: 'https://readdy.ai/api/search-image?query=Truck%20turbocharger%20cartridge%20CHRA%20on%20clean%20light%20gray%20background%2C%20precision%20engineering%20turbo%20component%2C%20shiny%20metallic%20housing%2C%20professional%20automotive%20parts%20photography&width=400&height=400&seq=turbo-p5&orientation=squarish',
    inStock: false,
  },
  {
    id: 6,
    name: 'Cabin Air Filter Set',
    category: 'engine',
    brand: 'MAHLE',
    image: 'https://readdy.ai/api/search-image?query=Truck%20cabin%20air%20filter%20set%20on%20clean%20light%20gray%20background%2C%20professional%20automotive%20parts%20photography%2C%20rectangular%20filter%20element%2C%20commercial%20product%20shot&width=400&height=400&seq=cabin-filter-p6&orientation=squarish',
    inStock: true,
  },
  // Braking
  {
    id: 23,
    name: 'GB Group Brake Pads for European Trucks',
    category: 'braking',
    brand: 'GB Group',
    image: 'https://static.readdy.ai/image/87705512d5c7f2a4b5504cc452accb9e/751e3df8f271da84c510cacdb1509d83.jpeg',
    inStock: true,
    featured: true,
  },
  {
    id: 7,
    name: 'Brake Disc Set Premium',
    category: 'braking',
    brand: 'Knorr-Bremse',
    image: 'https://readdy.ai/api/search-image?query=Heavy%20duty%20truck%20brake%20disc%20rotor%20set%20on%20clean%20light%20gray%20studio%20background%2C%20cast%20iron%20ventilated%20disc%2C%20precision%20machined%20grooves%2C%20professional%20automotive%20braking%20parts%20photography&width=400&height=400&seq=brake-disc-p7&orientation=squarish',
    inStock: true,
    featured: true,
  },
  {
    id: 8,
    name: 'Brake Pad Kit Heavy Duty',
    category: 'braking',
    brand: 'Wabco',
    image: 'https://readdy.ai/api/search-image?query=Heavy%20duty%20truck%20brake%20pad%20kit%20on%20clean%20light%20gray%20background%2C%20professional%20automotive%20braking%20parts%20photography%2C%20friction%20material%20pads%20metallic%20backing%2C%20commercial%20product%20shot&width=400&height=400&seq=brake-pad-p8&orientation=squarish',
    inStock: true,
  },
  {
    id: 9,
    name: 'Brake Caliper Assembly',
    category: 'braking',
    brand: 'Knorr-Bremse',
    image: 'https://readdy.ai/api/search-image?query=Truck%20brake%20caliper%20assembly%20on%20clean%20light%20gray%20background%2C%20precision%20engineered%20braking%20component%2C%20metallic%20casing%2C%20professional%20automotive%20parts%20photography&width=400&height=400&seq=brake-caliper-p9&orientation=squarish',
    inStock: true,
  },
  {
    id: 10,
    name: 'Brake Chamber Spring',
    category: 'braking',
    brand: 'Wabco',
    image: 'https://readdy.ai/api/search-image?query=Truck%20air%20brake%20chamber%20spring%20actuator%20on%20clean%20light%20gray%20background%2C%20cylindrical%20steel%20housing%2C%20professional%20commercial%20vehicle%20braking%20system%20parts%20photography&width=400&height=400&seq=brake-chamber-p10&orientation=squarish',
    inStock: false,
  },
  // Suspension
  {
    id: 11,
    name: 'Leaf Spring Complete Set',
    category: 'suspension',
    brand: 'SAF-Holland',
    image: 'https://readdy.ai/api/search-image?query=Heavy%20duty%20truck%20leaf%20spring%20set%20on%20clean%20light%20gray%20background%2C%20layered%20steel%20springs%2C%20professional%20automotive%20suspension%20parts%20photography%2C%20commercial%20product%20shot&width=400&height=400&seq=leaf-spring-p11&orientation=squarish',
    inStock: true,
    featured: true,
  },
  {
    id: 12,
    name: 'Shock Absorber Premium',
    category: 'suspension',
    brand: 'Sachs',
    image: 'https://readdy.ai/api/search-image?query=Truck%20heavy%20duty%20shock%20absorber%20on%20clean%20light%20gray%20background%2C%20telescopic%20damper%20chrome%20rod%2C%20professional%20automotive%20suspension%20parts%20photography%2C%20commercial%20product%20studio%20shot&width=400&height=400&seq=shock-absorber-p12&orientation=squarish',
    inStock: true,
  },
  {
    id: 13,
    name: 'Air Suspension Bellows',
    category: 'suspension',
    brand: 'BPW',
    image: 'https://readdy.ai/api/search-image?query=Truck%20air%20suspension%20bellow%20rubber%20airbag%20on%20clean%20light%20gray%20background%2C%20professional%20commercial%20vehicle%20parts%20photography%2C%20black%20rubber%20inflatable%20component&width=400&height=400&seq=air-bellow-p13&orientation=squarish',
    inStock: true,
  },
  {
    id: 14,
    name: 'Steering Tie Rod End',
    category: 'suspension',
    brand: 'ZF',
    image: 'https://readdy.ai/api/search-image?query=Truck%20steering%20tie%20rod%20end%20ball%20joint%20on%20clean%20light%20gray%20background%2C%20metallic%20precision%20engineering%20component%2C%20professional%20automotive%20steering%20parts%20photography&width=400&height=400&seq=tie-rod-p14&orientation=squarish',
    inStock: false,
  },
  // Lighting
  {
    id: 15,
    name: 'LED Headlight Kit Complete',
    category: 'lighting',
    brand: 'Hella',
    image: 'https://readdy.ai/api/search-image?query=Modern%20LED%20truck%20headlight%20assembly%20kit%20on%20clean%20light%20gray%20background%2C%20professional%20automotive%20lighting%20parts%20photography%2C%20bright%20LED%20elements%20and%20reflector%20housing%2C%20commercial%20product%20shot&width=400&height=400&seq=led-head-p15&orientation=squarish',
    inStock: true,
    featured: true,
  },
  {
    id: 16,
    name: 'LED Tail Light Assembly',
    category: 'lighting',
    brand: 'Aspock',
    image: 'https://readdy.ai/api/search-image?query=LED%20truck%20tail%20light%20assembly%20on%20clean%20light%20gray%20background%2C%20professional%20automotive%20lighting%20parts%20photography%2C%20red%20and%20amber%20LED%20elements%2C%20commercial%20product%20studio%20shot&width=400&height=400&seq=led-tail-p16&orientation=squarish',
    inStock: true,
  },
  {
    id: 17,
    name: 'Side Marker Light Set',
    category: 'lighting',
    brand: 'Hella',
    image: 'https://readdy.ai/api/search-image?query=Truck%20trailer%20side%20marker%20amber%20LED%20lights%20set%20on%20clean%20light%20gray%20background%2C%20small%20rectangular%20lighting%20units%2C%20professional%20automotive%20parts%20photography&width=400&height=400&seq=side-marker-p17&orientation=squarish',
    inStock: true,
  },
  {
    id: 18,
    name: 'Work Lamp LED Round',
    category: 'lighting',
    brand: 'Hella',
    image: 'https://readdy.ai/api/search-image?query=Round%20LED%20work%20lamp%20spotlight%20for%20truck%20on%20clean%20light%20gray%20background%2C%20aluminum%20housing%20bright%20LED%20chip%2C%20professional%20automotive%20lighting%20parts%20photography&width=400&height=400&seq=work-lamp-p18&orientation=squarish',
    inStock: true,
  },
  // Trailer
  {
    id: 19,
    name: 'Fifth Wheel Coupling',
    category: 'trailer',
    brand: 'Jost',
    image: 'https://readdy.ai/api/search-image?query=Heavy%20duty%20fifth%20wheel%20coupling%20kingpin%20trailer%20on%20clean%20light%20gray%20background%2C%20cast%20iron%20coupling%20plate%2C%20professional%20commercial%20vehicle%20parts%20photography&width=400&height=400&seq=fifth-wheel-p19&orientation=squarish',
    inStock: true,
  },
  {
    id: 20,
    name: 'Landing Gear Legs Set',
    category: 'trailer',
    brand: 'SAF-Holland',
    image: 'https://readdy.ai/api/search-image?query=Trailer%20landing%20gear%20support%20legs%20set%20on%20clean%20light%20gray%20background%2C%20steel%20extendable%20support%20mechanism%2C%20professional%20commercial%20vehicle%20parts%20photography&width=400&height=400&seq=landing-gear-p20&orientation=squarish',
    inStock: true,
  },
  {
    id: 21,
    name: 'Trailer Axle Assembly',
    category: 'trailer',
    brand: 'BPW',
    image: 'https://readdy.ai/api/search-image?query=Trailer%20axle%20complete%20assembly%20on%20clean%20light%20gray%20background%2C%20steel%20beam%20hub%20drums%2C%20professional%20commercial%20vehicle%20parts%20photography%2C%20industrial%20product%20shot&width=400&height=400&seq=trailer-axle-p21&orientation=squarish',
    inStock: false,
  },
  {
    id: 22,
    name: 'Trailer Brake Controller',
    category: 'trailer',
    brand: 'Wabco',
    image: 'https://readdy.ai/api/search-image?query=Trailer%20electronic%20brake%20controller%20module%20on%20clean%20light%20gray%20background%2C%20black%20electronic%20device%20connectors%2C%20professional%20automotive%20electronics%20photography&width=400&height=400&seq=trailer-brake-ctrl-p22&orientation=squarish',
    inStock: true,
  },
];

export const featuredProducts = allProducts.filter((p) => p.featured);
